// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.fees.singlefamily.RentalManagerUserPropertySingleFamilyCostAndFeesV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { DeleteSingleFamilyListingFeesRequestDto } from '../..';

export const RentalManagerUserPropertySingleFamilyCostAndFeesV2WebApiHandler_delete_Path =
  '/api/web/v2/users/properties/fees/singleFamily/delete';

/**
 * Deletes a fee for a single family listing
 */
export const RentalManagerUserPropertySingleFamilyCostAndFeesV2WebApiHandler_delete = (
  postData: DeleteSingleFamilyListingFeesRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, DeleteSingleFamilyListingFeesRequestDto, void>(
    {
      endpoint: RentalManagerUserPropertySingleFamilyCostAndFeesV2WebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
